import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { connect } from 'react-redux'

import { StyledPressIcon } from "sheets/components/style"
import { pressImageConnection } from "sheets/components/cells/cell-selectors/datum-cell-selectors"


/**
 * Renders either a press contact's picture if it's available,
 * otherwise render the microphone icon
 */
export const PressImage = ({ containsImageUrl, imageUrl, personName }) => (
    containsImageUrl ? (
        <img
            alt={personName}
            className={classNames("sheet-row-image")}
            src={imageUrl}
        />
    ) : (
        <StyledPressIcon>
            <i className="fa fa-microphone" />
        </StyledPressIcon>
    )
)


export default connect(pressImageConnection)(PressImage)

PressImage.propTypes = {
    /** Whether or not the person's image exists */
    containsImageUrl: PropTypes.bool,
    /** The name of the person */
    personName: PropTypes.string,
    /** The url containing the person's photo */
    imageUrl: PropTypes.string,
}
